import type { CandidateStage } from '@/modules/hiring-manager/hooks/useCandidatePipelineQuery';
import type { JobAutomation } from '@/pages/hm/job-automation/jobAutomation';

/** Who moves a step forward: Finlay's agents or the customer. */
export type StepOwner = 'finlay' | 'you';

/**
 * Who acts next on the people in a stage, matching the job's steps in
 * `getJobActivity`; undefined when nobody does: sourced matches Finlay will
 * not contact, and the closed outcomes. Interview scheduling is not on the
 * platform yet, so interviews are the user's.
 */
export const stageOwner = (
  stage: CandidateStage,
  automation: JobAutomation,
): StepOwner | undefined => {
  switch (stage) {
    case 'sourced':
      return automation.outreach === 'me' ? 'you' : undefined;
    case 'shortlisted':
    case 'outreach':
      return automation.outreach === 'finlay' ? 'finlay' : 'you';
    case 'prescreening':
      return automation.prescreen === 'ai' ? 'finlay' : 'you';
    case 'waiting':
    case 'interviewing':
      return 'you';
    case 'hired':
    case 'passed':
      return undefined;
  }
};
